/** Deliberate vs reactive anger — recognition-based vs control-based */

export const ANGER_TYPE_HEALING = "healing";
export const ANGER_TYPE_SURVIVAL = "survival";

export const ANGER_TYPE_LABELS = {
  healing: "Deliberate anger",
  survival: "Reactive anger"
};

export const ANGER_TYPE_TAGLINE = {
  healing: "Examines the interpretation",
  survival: "Driven by control"
};

export const ANGER_TYPE_DESCRIPTION = {
  healing:
    "Anger used to recognize patterns—shrinking yourself, tolerating harm, or abandoning boundaries—and update the interpretation behind the reaction.",
  survival:
    "Anger that shows up as threats, blame, dominance, or needing power over others—often reactive and costly."
};

export const ANGER_TYPE_COLORS = {
  healing: "#5b8fa8",
  survival: "#a65c5c"
};

export function getHealthyAngerLabel(score) {
  if (score >= 75) return "Mostly deliberate anger";
  if (score >= 55) return "Leaning deliberate";
  if (score >= 45) return "Mixed";
  if (score >= 25) return "Leaning reactive";
  return "Mostly reactive anger";
}
